import { useState } from "react";
import i18n, { languages } from "../i18n";
import { useTranslation } from "react-i18next";
import EnglishFlag from "../Assets/flags/en.svg";

import { useNavigate } from "react-router-dom";
import { useLoading } from "../Context/LoadingProvider";
import { useUser } from "../Context/UserProvider";
import { useNotifications } from "../Context/NotificationProvider";

import { ArrowDownIcon } from "../Components/Icons/ArrowDownIcon";
import { ArrowUpIcon } from "../Components/Icons/ArrowUpIcon";
import { UserIcon } from "../Components/Icons/UserIcon";
//import { ProfileSettingsIcon } from "../Components/Icons/ProfileSettingsIcon";
//import { NotificationIcon } from "../Components/Icons/NotificationIcon";
import { LogoutIcon } from "../Components/Icons/LogoutIcon";

import LanguageSelectModal from "./LanguageSelectModal";

interface UserNavigationProps {}

const UserNavigation: React.FunctionComponent<UserNavigationProps> = () => {
  const navigate = useNavigate();
  const { startLoading, finnishLoading } = useLoading();
  const { logout, user } = useUser();
  const { notifications } = useNotifications();
  
  const [showNavigationPanel, setShowNavigationPanel] =
    useState<boolean>(false);

  const [showLanguageSelectModal, setShowLanguageSelectModal] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleLogout = () => {
    startLoading("logout");
    logout()
      .then(() => {
        navigate("/");
      })
      .finally(() => {
        finnishLoading("logout");
      });
  };
  return (
    <>
      
      <div 
        className={showNavigationPanel ? "user-navigation-toggler user-navigation-toggler--opened" : "user-navigation-toggler"}
        onClick={() => setShowNavigationPanel(showNavigationPanel ? false : true)}
      >
        <div className="small-user-avatar">
          {notifications?.hasUnread && (
              <div className="small-user-avatar__marker"></div>
          )}
            {user?.userAvatar ? (
                <img src={user.userAvatar} width="32" height="32" alt="user" />
            ) : (
                <div className="no-avatar">
                    <UserIcon />
                </div>
            )}
        </div>
        
        {showNavigationPanel ?  <ArrowUpIcon/> : <ArrowDownIcon/> }
      </div>
        
      <div
        className={"top-layer " + (showNavigationPanel ? "" : "hidden")}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
      >
        <div className="top-layer__overlay"></div>
          <div className="top-layer__body">
            <div className="heading mb-6">{user?.name || "Guest"}</div>
            <ul className="modal__list">

                {/*<li onClick={() => {
                  navigate('/user-profile/settings');
                  setShowNavigationPanel(false);
                }}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <ProfileSettingsIcon />
                      {t("Profile Settings")}
                    </div>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                        <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                        <g transform="matrix(-1,0,0,1,5.71937,0)">
                          <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                      </svg>
                  </div>
                </li>

                <li onClick={() => {
                  navigate('/notification/list');
                  setShowNavigationPanel(false);
                }}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="relative">
                        {notifications?.hasUnread && (
                          <div className="marker"></div>
                          )}
                        <NotificationIcon/>
                      </div>

                      {t("Notifications")}

                      {(notifications?.count ?? 0) > 0 && (
                          <div className="marker-info">{notifications?.count}</div>
                      )}
                    </div>

                    <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                        <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                        <g transform="matrix(-1,0,0,1,5.71937,0)">
                          <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                      </svg>
                  </div>
                </li> */}

                <li onClick={() => setShowLanguageSelectModal(true)}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div 
                        className="language-selector__list-image" 
                        style={{ backgroundImage: `url("${languages.find((x) => x.key === i18n.language)?.flag ?? EnglishFlag}")` }}
                      ></div>
                      {t("Language")}
                    </div>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                        <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                        <g transform="matrix(-1,0,0,1,5.71937,0)">
                          <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                      </svg>
                  </div>
                </li>

                <li onClick={handleLogout}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <LogoutIcon />
                      {t("Logout")}
                    </div>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                        <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                        <g transform="matrix(-1,0,0,1,5.71937,0)">
                          <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                      </svg>
                  </div>
                </li>
              
            </ul>
          </div>
        </div>

        <LanguageSelectModal
          show={showLanguageSelectModal}
          onClose={() => setShowLanguageSelectModal(false)}
        />
     
    </>
  );
};

export default UserNavigation;
